import { Pipe, PipeTransform } from '@angular/core';
import { CommentMailModel, CommentModel, isMailComment } from '@dta/shared/models-api-loop/comment/comment.model';

@Pipe({
  name: 'isMailComment',
  standalone: false
})
export class IsMailCommentPipe implements PipeTransform {
  transform(comment: CommentModel): comment is CommentMailModel {
    return isMailComment(comment);
  }
}
